import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  useGetAllCourseListMutation,
  useGetAssignmentFoldersMutation,
  useGetAllAssignedViaMutation,
  useGetAllAssignmentStatusMutation
} from '../../features/authentication/authApiSlice';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [courseData, setCourseData] = useState([]);
  const [folderData, setFolderData] = useState([]);
  const [assignedViaData, setAssignedViaData] = useState([]);
  const [assignmentStatusData, setAssignmentStatusData] = useState([]);
  const [reloadFolders, setReloadFolders] = useState(false);
  const [getAllCourses] = useGetAllCourseListMutation();
  const [getAllFolders] = useGetAssignmentFoldersMutation();
  const [getAllAssignedVia] = useGetAllAssignedViaMutation();
  const [getAllAssignmentStatus] = useGetAllAssignmentStatusMutation();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const mathSkillCourses = [14,26,101];

  useEffect(() => {
    const fetchCourseData = async () => {
      if(!isDataLoaded)
      {
        try {
          setCourseData(await getAllCourses().unwrap());
          setFolderData(await getAllFolders().unwrap());
          setAssignedViaData(await getAllAssignedVia().unwrap());
          setAssignmentStatusData(await getAllAssignmentStatus().unwrap());
          setIsDataLoaded(true);
        } catch (error) {}
      }
    };

    fetchCourseData();
  }, []);

  useEffect(() => {
    const reloadFoldersAsync = async ()=>{
      if(reloadFolders)
        setFolderData(await getAllFolders().unwrap());
      setReloadFolders(false);
    }; 
    reloadFoldersAsync();
  }, [reloadFolders]);



  return (
    <DataContext.Provider value={{ courseData, folderData, assignedViaData, assignmentStatusData, setReloadFolders, mathSkillCourses }}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => {
  return useContext(DataContext);
};
